import { render } from "./WeightStatistic.vue?vue&type=template&id=0591fe60&bindings={}"
import script from "./WeightStatistic.vue?vue&type=script&lang=ts"
export * from "./WeightStatistic.vue?vue&type=script&lang=ts"
script.render = render

export default script